import { Controller } from "@hotwired/stimulus"

// Admin AiTutor form: the Content section is only used by exercise tutors, so
// hide it when the Tutor Type is "book_tutor" (book tutors are content-agnostic —
// their context comes from the chapter the student is reading). The model
// select is per tutor type too (OpenAI for exercise tutors, Claude for book
// tutors): both selects post ai_tutor[model], so the hidden one is disabled
// to keep it out of the form data.
export default class extends Controller {
  static targets = ["kind", "content", "bookOnly", "exerciseOnly", "exerciseModel", "bookModel"]

  connect() {
    this.toggleContent()
  }

  toggleContent() {
    if (!this.hasKindTarget) return
    const isBook = this.kindTarget.value === "book_tutor"
    if (this.hasContentTarget) this.contentTarget.hidden = isBook
    this.bookOnlyTargets.forEach((el) => { el.hidden = !isBook })
    this.exerciseOnlyTargets.forEach((el) => { el.hidden = isBook })
    if (this.hasExerciseModelTarget) this.exerciseModelTarget.disabled = isBook
    if (this.hasBookModelTarget) this.bookModelTarget.disabled = !isBook
  }
}
